window.dataLayer = window.dataLayer || [];

function getItemsFromLineItems(lineItems) {
  const items = lineItems.map((item, index) => ({
    item_id: item.variant.sku,
    item_name: item.variant.product.title,
    index,
    item_brand: item.variant.product.vendor,
    price: item.variant.price.amount,
    item_quantity: item.quantity,
  }));

  return items;
}

function getItemsFromCollectionVariants(collection) {
  const items = collection.productVariants.map((item, index) => ({
    item_id: item.sku,
    item_name: item.product.title,
    index,
    item_brand: item.product.vendor,
    price: item.price.amount,
  }));

  return items;
}

function getItemFromCartLine(cartLine) {
  return {
    item_id: cartLine.merchandise.sku,
    item_name: cartLine.merchandise.product.title,
    item_brand: cartLine.merchandise.product.vendor,
    price: cartLine.merchandise.price.amount,
    item_quantity: cartLine.quantity,
  };
}

addEventListener('message', function (e) {
  if (!e.data.pixelEvent) return;

  const { event } = e.data;

  switch (event.name) {
    case 'page_viewed':
      window.dataLayer.push({
        ...event.data,
      });
      break;
    case 'product_viewed':
      window.dataLayer.push({
        event: 'product_viewed',
        ecommerce: {
          currency: event.data.productVariant.price.currencyCode,
          value: event.data.productVariant.price.amount,
          items: [
            {
              item_id: event.data.productVariant.sku,
              item_name: event.data.productVariant.product.title,
              item_brand: event.data.productVariant.product.vendor,
              price: event.data.productVariant.price.amount,
            },
          ],
        },
      });
      break;
    case 'collection_viewed':
      window.dataLayer.push({
        event: 'collection_viewed',
        ecommerce: {
          item_list_id: event.data.collection.id,
          item_list_name: event.data.collection.title,
          currency: event.data.collection.productVariants.length
            ? event.data.collection.productVariants[0].price.currencyCode
            : undefined,
          items: getItemsFromCollectionVariants(event.data.collection),
        },
      });
      break;
    case 'search_submitted':
      window.dataLayer.push({
        event: 'search_submitted',
        ecommerce: { search_term: event.data.searchResult.query },
      });
      break;
    case 'product_added_to_cart':
      window.dataLayer.push({
        event: 'product_added_to_cart',
        ecommerce: {
          content_type: 'product',
          content_name: event.data.cartLine.merchandise.product.title,
          currency: event.data.cartLine.merchandise.price.currencyCode,
          value: event.data.cartLine.merchandise.price.amount,
          items: [getItemFromCartLine(event.data.cartLine)],
        },
      });
      break;
    case 'product_removed_from_cart':
      window.dataLayer.push({
        event: 'product_removed_from_cart',
        ecommerce: {
          currency: event.data.cartLine.merchandise.price.currencyCode,
          value: event.data.cartLine.merchandise.price.amount,
          items: [getItemFromCartLine(event.data.cartLine)],
        },
      });
      break;
    case 'cart_viewed':
      window.dataLayer.push({
        event: 'cart_viewed',
        ecommerce: {
          currency: event.data.cart.cost.totalAmount.currencyCode,
          value: event.data.cart.cost.totalAmount.amount,
          items: event.data.cart.lines.map(getItemFromCartLine),
        },
      });
      break;
    case 'checkout_started':
      window.dataLayer.push({
        event: 'checkout_started',
        ecommerce: {
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          coupon: event.data.checkout.coupon,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
        },
      });
      break;
    case 'payment_info_submitted':
      window.dataLayer.push({
        event: 'payment_info_submitted',
        ecommerce: {
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
        },
      });
      break;
    case 'checkout_contact_info_submitted':
      window.dataLayer.push({
        event: 'checkout_contact_info_submitted',
        ecommerce: {
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
          address: event.data.checkout.shippingAddress,
        },
      });
      break;
    case 'checkout_completed':
      window.dataLayer.push({
        event: 'checkout_completed',
        ecommerce: {
          transaction_id: event.data.checkout.order.id,
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
        },
      });
      break;
    default:
      window.dataLayer.push({ event: 'unknown_event', data: event });
      break;
  }
});
